import { render, staticRenderFns } from "./MeusPontosPage.vue?vue&type=template&id=5a665101&scoped=true"
import script from "./MeusPontosPage.vue?vue&type=script&lang=js"
export * from "./MeusPontosPage.vue?vue&type=script&lang=js"
import style0 from "./MeusPontosPage.vue?vue&type=style&index=0&id=5a665101&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a665101",
  null
  
)

export default component.exports